<template>
    <div class="rep-code-input">
      <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
        <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
          {{ options.label }}
        </label>
        <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
          <input
            class="form-control"
            type="text"
            :id="options.name"
            :value="value"
            :class="formControlValidationClass"
            :name="options.name"
            @input="validateField($event.target.value)"
          />
          <span :class="validationClass" v-show="validationMessage">
            {{ validationMessage }}
          </span>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import _ from 'lodash'
  import Api from '@/vuex/api'
  import {
    validationClass,
    formControlValidationClass,
    validationMessage
  } from '@/util/helpers'
  
  export default {
    name: 'RepCodeInput',
    props: {
      value: {
        type: String
      },
      options: {
        type: Object,
        default () {
          return {
            name: '', // Unique field name for this input
            label: '', // Label for the field
            maxLength: 6 // Maximum length of referral code
          }
        }
      }
    },
    data () {
      return {
        isValid: false, // Indicates overall validity
        isDirty: false, // Tracks if user has interacted
        isLength: true, // Tracks maxLength validation
        isLoading: false, // Tracks API loading state
        delayedValidate: null // Debounced validator reference
      }
    },
    computed: {
      validationClass,
      validationMessage,
      formControlValidationClass,
      invalidMessage () {
        if (!this.isLength) {
          return `${this.options.label} cannot be more than ${this.options.maxLength} characters`
        } else if (!this.isValid && this.value) {
          return 'Invalid representative code'
        } else {
          return ''
        }
      }
    },
    mounted () {
      // Set maxLength from options if provided
      if (this.options.maxLength) {
        this.maxLength = this.options.maxLength
      }
    },
    methods: {
      async checkRepCode () {
        this.isLoading = true
        try {
          const instance = new Api()
          const data = await instance.checkRepCode({ code: this.value })
          this.isLoading = false
          // Explicitly check the result property
          const isValidCode = data && data.result === true
          this.isValid = isValidCode
        } catch (error) {
          this.isLoading = false
          this.isValid = false
          console.error('Error validating referral code:', error)
        }
      },
      validateField (val = this.value) {
        this.$emit('input', val)
  
        // Reset debounce if active
        if (this.delayedValidate) {
          this.delayedValidate.cancel()
        }
  
        // Debounce the validation
        this.delayedValidate = _.debounce(async () => {
          // Perform basic validation first
          this.validate(val)
  
          // If passes basic validation, check with API
          if (this.isValid && val) {
            await this.checkRepCode() // Only trigger API if there's a value
          }
        }, 300, { 'leading': false, 'trailing': true })()
      },
      validate (val = this.value) {
        if (val) {
          this.isDirty = true
          // Check length first
          this.isLength = val.length <= this.options.maxLength
          this.isValid = this.isLength
        } else {
          // If no value, no need for API call
          this.isValid = true
        }
      }
    }
  }
  </script>
  


// WEBPACK FOOTER //
// src/components/inputs/RepCodeInput.vue